import { MetaType, AssetRef, CropType } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  processActionMeta,
  getArrayReducerGuard
} from "../reducers"

const kind = "block_images"

export type BlockImage = {
  kind: typeof kind
  version: number
  type: "image"
  assets: Array<AssetRef>
  cropped: boolean
  // crop: CropType
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<BlockImage, MetaType>("meta", kind),
  assets: actionCreatorGuard<BlockImage, Array<AssetRef>>("assets", kind),
  cropped: actionCreatorGuard<BlockImage, boolean>("cropped", kind),
  type: actionCreatorGuard<BlockImage, string>("type", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    BlockImage,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const blockImageAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const blockImageReducer = reducerGuard<BlockImage>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.assets)
  // .case(...reducerAction.crop)
  .case(...reducerAction.cropped)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "assets":
        return getArrayReducerGuard<BlockImage, AssetRef>(
          kind,
          "assets",
          "AssetRef",
          prevState,
          action
        )
    }

    return prevState
  })
